import { Button, List, Surface } from "react-native-paper";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useAppTheme } from "../../useAppTheme";
import useBreakpoints from "../../useBreakpoints";
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";

type Props = {
	cta: string;
	handleAction: (dismiss?: boolean) => void;
	disabled: boolean;
	subheader: string;
	title: string;
};
export const StickyActionFooter = ({
	cta,
	handleAction,
	disabled,
	subheader,
	title,
}: Props) => {
	const insets = useSafeAreaInsets();
	const theme = useAppTheme();
	const { xsDown, smUp } = useBreakpoints();
	return (
		<Surface
			style={{
				position: "absolute",
				bottom: 0,
				left: 0,
				right: 0,
				gap: 8,
				paddingTop: smUp ? 16 : 8,
				paddingBottom: insets.bottom + 16,
			}}
		>
			{xsDown && (
				<Box paddingHorizontal={16} gap={8}>
					<CustomListSubheader
						enableGutters={false}
						style={{ paddingVertical: 0 }}
					>
						{subheader}
					</CustomListSubheader>
					<List.Item
						title={title}
						style={{
							backgroundColor: theme.colors.surfaceDisabled,
							paddingVertical: 4,
						}}
						left={(p) => {
							return <List.Icon {...p} icon={"check"} />;
						}}
					/>
				</Box>
			)}
			<Box
				flexDirection="row"
				width="100%"
				alignItems="center"
				justifyContent="flex-end"
				paddingHorizontal={16}
				gap={8}
			>
				{smUp && (
					<Button onPress={() => handleAction(true)}>{"Dismiss"}</Button>
				)}
				<Button
					style={{
						width: smUp ? "auto" : "100%",
					}}
					disabled={disabled}
					mode="contained"
					onPress={() => handleAction(false)}
				>
					{cta}
				</Button>
			</Box>
		</Surface>
	);
};
